import { render, staticRenderFns } from "./IncreaseProductCategory.vue?vue&type=template&id=9ad981d0"
import script from "./IncreaseProductCategory.vue?vue&type=script&lang=js"
export * from "./IncreaseProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports